import { z } from 'zod';

import { idSchema, isoDateTimeSchema } from './common.js';

/**
 * Contexto do indicador no site:
 *   - home    : faixa de 4 cards na home
 *   - numeros : grade de 6 cards na página IDPE em Números
 *   - both    : aparece nos dois locais (mesmo valor)
 */
export const indicatorContextSchema = z.enum(['home', 'numeros', 'both']);
export type IndicatorContext = z.infer<typeof indicatorContextSchema>;

export const indicatorSchema = z.object({
  id: idSchema,
  chave: z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z0-9-]+$/, 'Chave deve ser kebab-case minúsculo.'),
  valor: z.string().min(1).max(80),
  prefixo: z.string().max(16).nullable(),
  sufixo: z.string().max(32).nullable(),
  descricao: z.string().min(1).max(200),
  contexto: indicatorContextSchema,
  ordem: z.number().int().min(0).max(9999),
  visivel: z.boolean(),
  criadoEm: isoDateTimeSchema,
  atualizadoEm: isoDateTimeSchema,
});
export type Indicator = z.infer<typeof indicatorSchema>;

export const createIndicatorInputSchema = z.object({
  chave: indicatorSchema.shape.chave,
  valor: indicatorSchema.shape.valor,
  prefixo: z.string().max(16).optional().or(z.literal('')),
  sufixo: z.string().max(32).optional().or(z.literal('')),
  descricao: indicatorSchema.shape.descricao,
  contexto: indicatorContextSchema,
  ordem: z.number().int().min(0).max(9999),
  visivel: z.boolean(),
});
export type CreateIndicatorInput = z.infer<typeof createIndicatorInputSchema>;

export const updateIndicatorInputSchema = createIndicatorInputSchema.partial();
export type UpdateIndicatorInput = z.infer<typeof updateIndicatorInputSchema>;

export const listIndicatorsQuerySchema = z.object({
  contexto: indicatorContextSchema.optional(),
  visivel: z.preprocess(
    (v) => (v === 'true' ? true : v === 'false' ? false : undefined),
    z.boolean().optional(),
  ),
});
export type ListIndicatorsQuery = z.infer<typeof listIndicatorsQuerySchema>;
